import type { AccountType } from '@application/types';
import { useValidation } from '@application/utils';
import type { MtApplicationsOwnModalFormValues } from '@presentation/components';
import type { FormikErrors } from 'formik';
import { useCallback } from 'react';

export const useValidateForm = () => {
  const { requiredMessage } = useValidation();

  const validate = useCallback(
    (currentAccountType: AccountType, values: MtApplicationsOwnModalFormValues) => {
      const errors: FormikErrors<MtApplicationsOwnModalFormValues> = {};

      if (!values.breed) {
        errors.breed = requiredMessage;
      }

      if (!values.name && currentAccountType === 'buyer') {
        errors.name = requiredMessage;
      }

      if (!values.birthday && values.action !== 'waitlist') {
        errors.birthday = requiredMessage;
      }

      if (!values.gender && values.action !== 'waitlist') {
        errors.gender = requiredMessage;
      }

      if (currentAccountType === 'breeder' && !values.action) {
        errors.action = requiredMessage;
      }

      return errors;
    },
    [requiredMessage],
  );

  return { validate };
};
